import { request } from "common";
import store from "@/store";
export function menuTree() {
  let userOrg = store.getters.userOrg;
  return request({
    url: "/portal/api/v1/user/menuperimission",
    method: "get",
    headers: {
      "org-code": userOrg.code,
    },
  });
}
